import * as Sentry from "@sentry/react";
import type { User } from "@upsquad/shared";
import posthog from "posthog-js";

export function identifyUser(user: User): void {
	Sentry.setUser({ id: user.id, email: user.email });
	posthog.identify(user.id, { email: user.email, name: `${user.first_name ?? ""} ${user.last_name ?? ""}`.trim() });
}

export function resetIdentity(): void {
	Sentry.setUser(null);
	posthog.reset();
}
